const baseImageUrl = `${process.env.REACT_APP_S3_BASE_URL}/29_april_revamp/use_cases`;

export const unlockNewConfig = [
	{
		id: 0,
		title: 'Product Promo Videos',
		description: 'Showcase products with AI characters in action.',
		image: `${baseImageUrl}/use_case_1.webp`,
	},
	{
		id: 1,
		title: 'UGC Style Ads',
		description: 'Create relatable, scroll-stopping ad content.',
		image: `${baseImageUrl}/use_case_2.webp`,
	},
	{
		id: 2,
		title: 'AI Influencers',
		description: 'Launch virtual brand ambassadors for marketing.',
		image: `${baseImageUrl}/use_case_3.webp`,
	},

	{
		id: 3,
		title: 'AI Fashion Shoots',
		description: 'Model your clothing line without photoshoots.',
		image: `${baseImageUrl}/use_case_4.webp`,
	},
	{
		id: 4,
		title: 'Ecommerce Visuals',
		description: 'Boost your listings with stunning visuals.',
		image: `${baseImageUrl}/use_case_5.webp`,
	},
	{
		id: 5,
		title: 'Digital Twins',
		description: 'Create AI versions of yourself',
		image: `${baseImageUrl}/use_case_6.webp`,
	},
];
